module.exports = __webpack_public_path__ + "img/isfj.ca8d36a0.png";